import React, {FC, useState} from 'react';

import {postAsync} from '../../../../../libs/shared/core/src/services/http/http';
import {usePushV2Events} from '../../../../../libs/shared/ui/src/push/usePushEvents';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getUser} from '../../../../store/data/teammates/teammatesSelectors';
import {ImpersonationRequestBanner} from '../../../app/banners/impersonation/impersonationRequestBanner';

export const DesktopImpersonationRequestBanner: FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const user = useAppSelector(getUser);

  usePushV2Events([
    {
      name: 'impersonate_request',
      handler: () => () => {
        setShowBanner(true);
      },
    },
  ]);

  const onImpersonationResultAsync = async (granted: boolean) => {
    setShowBanner(false);
    try {
      await postAsync(`${user.url}/impersonate`, {granted});
    } catch (error) {
      setShowBanner(true);
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <ImpersonationRequestBanner
      onAllowClick={() => onImpersonationResultAsync(true)}
      onDenyClick={() => onImpersonationResultAsync(false)}
    />
  );
};
